import { useState } from "react";
import { ImageOff } from "lucide-react";

export function ZoomableImage({ src, alt, className, previewSize = 240, testId }) {
  const [errored, setErrored] = useState(false);
  const showImage = src && !errored;

  return (
    <div className={`relative overflow-hidden group/zoom ${className || ""}`}>
      {showImage ? (
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-contain bg-white"
          onError={() => setErrored(true)}
          data-testid={testId}
        />
      ) : (
        <div className="w-full h-full bg-gray-100 flex items-center justify-center" data-testid={testId}>
          <ImageOff size={16} strokeWidth={1.5} className="text-gray-300" />
        </div>
      )}
      {showImage && (
        <div
          className="hidden group-hover/zoom:block absolute z-50 left-1/2 -translate-x-1/2 -top-2 -translate-y-full bg-white p-1.5 rounded-xl border border-gray-200 shadow-2xl pointer-events-none"
          data-testid={testId ? `${testId}-zoom-preview` : undefined}
        >
          <img
            src={src}
            alt={alt}
            style={{ width: previewSize, height: previewSize }}
            className="object-contain rounded-lg max-w-none bg-white"
          />
        </div>
      )}
    </div>
  );
}
